/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListAuditLogFacetsSecurity = {
  apikeyHeaderGramKey?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type ListAuditLogFacetsRequest = {
  /**
   * Project slug to filter facet values to a specific project.
   */
  projectSlug?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type ListAuditLogFacetsSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListAuditLogFacetsSecurity$outboundSchema: z.ZodMiniType<
  ListAuditLogFacetsSecurity$Outbound,
  ListAuditLogFacetsSecurity
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listAuditLogFacetsSecurityToJSON(
  listAuditLogFacetsSecurity: ListAuditLogFacetsSecurity,
): string {
  return JSON.stringify(
    ListAuditLogFacetsSecurity$outboundSchema.parse(listAuditLogFacetsSecurity),
  );
}

/** @internal */
export type ListAuditLogFacetsRequest$Outbound = {
  project_slug?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const ListAuditLogFacetsRequest$outboundSchema: z.ZodMiniType<
  ListAuditLogFacetsRequest$Outbound,
  ListAuditLogFacetsRequest
> = z.pipe(
  z.object({
    projectSlug: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlug: "project_slug",
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
    });
  }),
);

export function listAuditLogFacetsRequestToJSON(
  listAuditLogFacetsRequest: ListAuditLogFacetsRequest,
): string {
  return JSON.stringify(
    ListAuditLogFacetsRequest$outboundSchema.parse(listAuditLogFacetsRequest),
  );
}
